var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgDesign = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 24,
  height: 24,
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  stroke: "currentColor",
  strokeWidth: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  opacity: 0.5,
  d: "m3.5 3.5 4 4M13 11a2 2 0 1 1-4 0 2 2 0 0 1 4 0Z"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  d: "m13.999 19 5-5v-3.63c0-1.91 0-2.864-.346-3.64a4 4 0 0 0-1.417-1.69c-.705-.475-1.645-.641-3.525-.973l-7.21-1.273c-1.515-.267-2.272-.4-2.817-.169a2 2 0 0 0-1.06 1.06c-.231.545-.098 1.302.17 2.817l1.272 7.21c.332 1.88.498 2.82.973 3.525a4 4 0 0 0 1.69 1.417c.776.346 1.73.346 3.64.346h3.63Zm1 3 6.5-6.5a1.414 1.414 0 0 0 0-2v0a1.414 1.414 0 0 0-2 0l-6.5 6.5a1.414 1.414 0 0 0 0 2v0a1.414 1.414 0 0 0 2 0Z"
})));
export default SvgDesign;